import styled from 'styled-components';
import { themeColor } from '../../../../theme/getters';
import { Icon } from '../../icon';

export const OptionBar = styled.div`
  cursor: pointer;
  display: flex;
  padding: 12px 0;
  align-items: center;
  border-bottom: 1px solid ${themeColor('middleGray')};
  ${({ expanded }) => (expanded ? 'border-bottom: none' : '')};
`;

export const Container = styled.li`
  display: flex;
  flex-direction: column;
  padding: 0;
  font-size: 18px;
  line-height: 24px;

  :last-of-type {
    ${OptionBar} {
      border-bottom: none;
    }
  }
`;

export const SubOptions = styled.ul`
  width: 100%;
  list-style-type: none;
  padding: 0 0 8px 26px;
  border-bottom: 1px solid ${themeColor('middleGray')};
`;

export const ExpandIcon = styled(Icon)`
  display: flex;
  margin-left: auto;
  transition: transform 0.2s ease-in-out;
  transform: ${({ expanded }) => (expanded ? 'rotate(180deg)' : 'rotate(0)')};
`;

export const OptionLabel = styled.span`
  margin-right: 16px;
`;

export const SubOptionsCheckedLabel = styled.span`
  color: ${themeColor('border')};
  font-size: 14px;
  line-height: 18px;
  display: flex;
  flex: 1;
  margin-right: 16px;
`;
